// @ts-check

/**
 * Methods that manipulates searchform on frontpage and handles search is being updated
 */
export const searchFormHelper = () => {
  const countrySelect = /** @type{HTMLSelectElement} */ (document.getElementById('Geography_GeographyCountryId'));
  const geographyInput = /** @type{HTMLInputElement} */ (document.getElementById('Geography_Geographies_0__Geography'));
  const geographySuggestionId = /** @type{HTMLInputElement} */ (document.getElementById('Geography_Geographies_0__SuggestionId'));
  const geographyInputId = /** @type{HTMLInputElement} */ (document.getElementById('Geography_Geographies_0__Id'));
  const geographyInputLong = /** @type{HTMLInputElement} */ (document.getElementById('Geography_Geographies_0__GeographyLong'));
  const previousCountrySelect = /** @type{HTMLInputElement} */ (document.getElementById('Geography_PreviousCountryId'));

  return {
    countrySelect,
    geographyInput,

    /**
     * Sets country on select in the main form and triggers an update
     * @param {string} countryId
     */
    updateCountryId: (countryId) => {
      if (countrySelect != null) {
        countrySelect.value = countryId;
      }
      geographyInput.value = null;
      geographySuggestionId.value = null;
      if (countrySelect != null) {
        countrySelect.dispatchEvent(new Event('change', { cancelable: true, bubbles: true })); // Force form to update and make ajax request
      }
    },

    /**
     * Sets geography in the main form and triggers an update
     * @param {string} countryId
     * @param {string} geographyId,
     * @param {string} geographyName
     */
    updateGeography: (countryId, geographyId, geographyName) => {
      if (countrySelect != null) {
        countrySelect.value = countryId;
      }
      if (previousCountrySelect != null) {
        previousCountrySelect.value = countryId;
      }
      if (geographyId != null && geographyId !== '' && geographyId !== 'null') {
        geographyInput.value = geographyName;
        geographyInputId.value = geographyId;
        geographyInputLong.value = geographyName;
      }

      geographyInput.dispatchEvent(new Event('change', { cancelable: true, bubbles: true })); // Force form to update and make ajax request
    },
  };
};
